import { __commonJSMin as e } from "../../../../../../../_virtual/_rolldown/runtime.js";
//#region ../../node_modules/.pnpm/@intercom+intermoji@2.0.3/node_modules/@intercom/intermoji/lib/is_undefined.js
var t = /* @__PURE__ */ e(((e, t) => {
	t.exports = function(e) {
		return e === void 0;
	};
}));
//#endregion
export default t();
export { t as require_is_undefined };
